module.exports = __webpack_public_path__ + "img/salman2.ad326d2b.jpg";